import { render, staticRenderFns } from "./album-element.vue?vue&type=template&id=5e98bb5e&scoped=true&"
import script from "./album-element.vue?vue&type=script&lang=js&"
export * from "./album-element.vue?vue&type=script&lang=js&"
import style0 from "./album-element.vue?vue&type=style&index=0&id=5e98bb5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e98bb5e",
  null
  
)

export default component.exports